import { SpokenAdvice } from '../translations-types';

const translations: SpokenAdvice = {
  configDescription:
    'Stel de instructie (skill) in die de AI gebruikt, en beheer de aan/uit-classificaties voor de klant en de specialist. Deze worden samen met de ingesproken tekst en de eerdere producten/behandelingen naar de AI gestuurd.',
  instruction: 'Instructie (skill)',
  instructionPlaceholder: 'Beschrijf hoe de AI het advies moet opstellen…',
  customerClassifications: 'Classificaties klant',
  employeeClassifications: 'Classificaties specialist',
  classificationLabel: 'Label',
  addClassification: 'Classificatie toevoegen',
  knowledgeFiles: 'Kennis-bestanden',
  knowledgeFilesHint:
    'Bestanden die de AI als extra kennis gebruikt (PDF, afbeeldingen, documenten). PDF en afbeeldingen worden het best gelezen; overige documenten kunnen beperkt zijn — zet ze bij voorkeur om naar PDF.',
  uploadFile: 'Bestand uploaden',
  saved: 'Opgeslagen',
  panelTitle: 'Klantvoorbereidingskaart',
  record: 'Opnemen',
  stopRecording: 'Stop opname',
  generating: 'Advies genereren…',
  transcript: 'Transcriptie',
  advice: 'Advies',
  generated: 'Advies gegenereerd',
  generateError: 'Kon geen advies genereren.',
  micError: 'Geen toegang tot de microfoon.',
};

export default translations;
